(() => {
  'use strict';

  function openCartDrawer() {
    if (typeof window.openCartDrawer === 'function') {
      window.openCartDrawer();
      return true;
    }

    const trigger = document.getElementById('CustomCartTrigger');

    if (trigger) {
      trigger.click();
      return true;
    }

    return false;
  }

  function dispatchCartEvents() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
    document.dispatchEvent(new CustomEvent('wb:cart:updated'));
  }

  function setError(form, message) {
    const error = form ? form.querySelector('[data-wbls-error]') : null;

    if (!error) return;

    if (!message) {
      error.hidden = true;
      error.textContent = '';
      return;
    }

    error.hidden = false;
    error.textContent = message;
  }

  function setButtonState(button, state) {
    if (!button) return;

    const label = button.querySelector('[data-wbls-label]');
    const defaultLabel = button.dataset.labelDefault || (label ? label.textContent : '');
    const loadingLabel = button.dataset.labelLoading || 'Ajout…';
    const successLabel = button.dataset.labelSuccess || 'Ajouté';
    const errorLabel = button.dataset.labelError || 'Erreur';

    button.classList.remove('is-loading', 'is-success', 'is-error');

    if (state === 'loading') {
      button.disabled = true;
      button.classList.add('is-loading');
      if (label) label.textContent = loadingLabel;
      return;
    }

    if (state === 'success') {
      button.disabled = false;
      button.classList.add('is-success');
      if (label) label.textContent = successLabel;

      window.setTimeout(() => {
        button.classList.remove('is-success');
        if (label) label.textContent = defaultLabel;
      }, 1400);

      return;
    }

    if (state === 'error') {
      button.disabled = false;
      button.classList.add('is-error');
      if (label) label.textContent = errorLabel;

      window.setTimeout(() => {
        button.classList.remove('is-error');
        if (label) label.textContent = defaultLabel;
      }, 1400);

      return;
    }

    button.disabled = false;
    if (label) label.textContent = defaultLabel;
  }

  async function addToCart(form) {
    const variantInput = form.querySelector('[data-wbls-variant-input], [name="id"]');
    const quantityInput = form.querySelector('[name="quantity"]');

    if (!variantInput || !variantInput.value) {
      throw new Error('Variante introuvable.');
    }

    const variantId = Number(variantInput.value);
    const quantity = quantityInput && quantityInput.value ? Number(quantityInput.value) : 1;

    if (!variantId) {
      throw new Error('Variante invalide.');
    }

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: quantity || 1
          }
        ]
      })
    });

    let data = null;

    try {
      data = await response.json();
    } catch (error) {
      data = null;
    }

    if (!response.ok) {
      const message = data && data.description ? data.description : 'Impossible d’ajouter ce produit au panier.';
      throw new Error(message);
    }

    return data;
  }

  function initVariants(section) {
    const variantsWrap = section.querySelector('[data-wbls-variants]');
    const form = section.querySelector('[data-wbls-form]');
    const input = section.querySelector('[data-wbls-variant-input]');
    const button = section.querySelector('[data-wbls-button]');
    const label = section.querySelector('[data-wbls-label]');

    if (!variantsWrap || !input || variantsWrap.dataset.wblsReady === 'true') return;

    variantsWrap.dataset.wblsReady = 'true';

    variantsWrap.addEventListener('click', (event) => {
      const variantButton = event.target.closest('[data-wbls-variant]');

      if (!variantButton || variantButton.disabled || variantButton.classList.contains('is-disabled')) return;

      variantsWrap.querySelectorAll('[data-wbls-variant]').forEach((item) => {
        item.classList.remove('is-selected');
        item.setAttribute('aria-pressed', 'false');
      });

      variantButton.classList.add('is-selected');
      variantButton.setAttribute('aria-pressed', 'true');

      input.value = variantButton.dataset.variantId || input.value;

      const available = variantButton.dataset.variantAvailable === 'true';

      if (button) {
        button.disabled = !available;
        button.classList.remove('is-loading', 'is-success', 'is-error');

        if (label) {
          label.textContent = available
            ? (button.dataset.labelDefault || label.textContent)
            : (button.dataset.labelSoldout || 'Épuisé');
        }
      }

      if (form) setError(form, '');
    });
  }

  function initForm(section) {
    const forms = section.querySelectorAll('[data-wbls-form]');

    forms.forEach((form) => {
      if (form.dataset.wblsReady === 'true') return;

      form.dataset.wblsReady = 'true';

      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        const button = form.querySelector('[data-wbls-button]');

        if (!button || button.classList.contains('is-loading') || button.disabled) return;

        setError(form, '');
        setButtonState(button, 'loading');

        try {
          await addToCart(form);
          dispatchCartEvents();
          openCartDrawer();
          setButtonState(button, 'success');
        } catch (error) {
          setError(form, error && error.message ? error.message : 'Impossible d’ajouter ce produit au panier.');
          setButtonState(button, 'error');
        }
      });
    });
  }

  function initSlider(section) {
    if (!section || section.dataset.wblsSliderReady === 'true') return;

    section.dataset.wblsSliderReady = 'true';

    const copies = Array.from(section.querySelectorAll('[data-wbls-copy]'));
    const cards = Array.from(section.querySelectorAll('[data-wbls-card]'));
    const dots = Array.from(section.querySelectorAll('[data-wbls-dot]'));
    const prev = section.querySelector('[data-wbls-prev]');
    const next = section.querySelector('[data-wbls-next]');
    const visual = section.querySelector('[data-wbls-visual]');
    const stage = section.querySelector('[data-wbls-stage]');
    const autoplay = section.dataset.autoplay === 'true';
    const speed = Number(section.dataset.autoplaySpeed || 5000);

    let index = cards.findIndex((card) => card.classList.contains('is-active'));
    let timer = null;
    let touchStartX = 0;
    let touchStartY = 0;
    let locked = false;

    if (index < 0) index = 0;

    const getPrevIndex = () => (index - 1 + cards.length) % cards.length;
    const getNextIndex = () => (index + 1) % cards.length;

    const unlock = () => {
      window.setTimeout(() => {
        locked = false;
      }, 360);
    };

    const setSlide = (targetIndex) => {
      if (!cards.length || locked) return;

      locked = true;
      index = (targetIndex + cards.length) % cards.length;

      const prevIndex = getPrevIndex();
      const nextIndexValue = getNextIndex();

      copies.forEach((copy, copyIndex) => {
        const active = copyIndex === index;
        copy.classList.toggle('is-active', active);
        copy.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      cards.forEach((card, cardIndex) => {
        card.classList.remove('is-active', 'is-prev', 'is-next', 'is-hidden', 'is-entering');

        if (cardIndex === index) {
          card.classList.add('is-active', 'is-entering');
          card.setAttribute('aria-hidden', 'false');

          window.setTimeout(() => {
            card.classList.remove('is-entering');
          }, 220);
        } else if (cardIndex === prevIndex) {
          card.classList.add('is-prev');
          card.setAttribute('aria-hidden', 'true');
        } else if (cardIndex === nextIndexValue) {
          card.classList.add('is-next');
          card.setAttribute('aria-hidden', 'true');
        } else {
          card.classList.add('is-hidden');
          card.setAttribute('aria-hidden', 'true');
        }
      });

      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });

      unlock();
    };

    const restart = () => {
      if (!autoplay || cards.length < 2) return;
      window.clearInterval(timer);
      timer = window.setInterval(() => setSlide(index + 1), speed);
    };

    if (prev) {
      prev.addEventListener('click', () => {
        setSlide(index - 1);
        restart();
      });
    }

    if (next) {
      next.addEventListener('click', () => {
        setSlide(index + 1);
        restart();
      });
    }

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        setSlide(Number(dot.dataset.wblsDot || 0));
        restart();
      });
    });

    if (stage) {
      stage.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          setSlide(index - 1);
          restart();
        }

        if (event.key === 'ArrowRight') {
          setSlide(index + 1);
          restart();
        }
      });
    }

    if (visual) {
      visual.addEventListener('touchstart', (event) => {
        const touch = event.touches[0];

        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
      }, { passive: true });

      visual.addEventListener('touchend', (event) => {
        const touch = event.changedTouches[0];
        const deltaX = touch.clientX - touchStartX;
        const deltaY = touch.clientY - touchStartY;

        if (Math.abs(deltaX) < 36 || Math.abs(deltaX) < Math.abs(deltaY)) return;

        if (deltaX < 0) {
          setSlide(index + 1);
        } else {
          setSlide(index - 1);
        }

        restart();
      }, { passive: true });
    }

    if (autoplay && cards.length > 1) {
      timer = window.setInterval(() => setSlide(index + 1), speed);

      section.addEventListener('mouseenter', () => window.clearInterval(timer));
      section.addEventListener('mouseleave', restart);
      section.addEventListener('focusin', () => window.clearInterval(timer));
      section.addEventListener('focusout', restart);
    }
  }

  function initSection(section) {
    initSlider(section);
    initVariants(section);
    initForm(section);
  }

  function init(root = document) {
    root.querySelectorAll('[id^="wb-brand-lab-slider-"]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();